export default "__VITE_PUBLIC_ASSET__59504a05__"